<div
  class="ui-selector-item ui-clickable flex-row start-center"
  (click)="toggleDropdown()"
  role="button"
  tabindex="0"
  aria-haspopup="true"
  #triggerElement
>
  <ng-content select="[input]"></ng-content>
</div>

<div
  *ngIf="isOpen"
  #dropdownPanel
  class="content-wrapper ui-selector-panel"
  [style.max-height.px]="height"
  [style.left.px]="dropdownPosition.left"
  [style.top.px]="dropdownPosition.top"
  role="menu"
  tabindex="0"
>
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</div>

<div
  #hiddenContainer
  class="ui-selector-panel ui-selector-panel--measure"
  aria-hidden="true"
>
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</div>
